module.exports = __webpack_public_path__ + "img/woman.126ce067.png";